import React, { ReactElement } from "react"
import "./Tooltip.scss"

type Props = {
  children: ReactElement
  content: string
  dark?: boolean
  placement?: "top" | "bottom" | "left" | "right"
  isDisabled?: boolean
}

const Tooltip = ({ children, content, dark = false, placement = "top", isDisabled = false }: Props): ReactElement => {
  if (isDisabled) {
    return children
  }

  return (
    <div className="group relative">
      <div
        className={`tooltip-${placement} ${dark ? "dark" : ""} rounded-md z-50 pointer-events-none
            text-xs absolute opacity-0 transition-opacity group-hover:opacity-100 p-2`}
      >
        {content}
      </div>
      {children}
    </div>
  )
}

export default Tooltip
